// Published backend lifecycle contract verified. Single release rollback switch.
export const aiChatFeatures = { incognitoDelete: true };
